import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import Button from '../../../common/Button';
import { Currency } from '../../../common/currency';
import { constants } from '../../../common/constants/constants';
import { useAccessToken } from '../../../common/hooks/useAccessToken';
import check from '../../../images/newDesign/check.svg';
import cashRegister from '../../../images/newDesign/cash_register.svg';
import BllinkUtils from '../../../common/utils/utils';
import { showLoader, hideLoader } from '../../../store/common/slice';

const Confirmation = ({ 
        vendorName, 
        amount, 
        date, 
        paymentMethod, 
        currency, 
        onHide, 
        addExpensePayload, 
        addPaymentMethodPayload,
        setShowConfirmation,
        setShowAddExpense,
        setShowAddPaymentMethod,
        setChoosePaymentMethod,
        paymentPlanID,
        showFromReport,
        loadExpenses 
    }) => {
    const { t } = useTranslation();
    const client = useAccessToken();
    const dispatch = useDispatch();
    document.querySelector('.fade').scrollTo(0,0);
    
    const currencySign = t(`currency.${currency}`);
    const dateWithoutTimeZone = BllinkUtils.BllinkTime.getTimeZoneOffset(new Date(date));
    const parsedDate = BllinkUtils.BllinkTime.parseDate(dateWithoutTimeZone);
    const parsedPaymentMethod = Object.keys(constants.managerPaymentsOptions).find(key => constants.managerPaymentsOptions[key] === paymentMethod);

    const onApproveClick = async () => {
        dispatch(showLoader());
        if (!paymentPlanID) {
            const response = await client.managers.expenses.addExpense(addExpensePayload);
            if (response.success) {
                const responseNext = await client.managers.expenses.setPayment(response.result.PaymentPlanId, addPaymentMethodPayload);
                if (responseNext.success) {
                    onHide();
                    NotificationManager.success(t('expenses.set_expenses.setExpenseSuccess'))
                } else NotificationManager.error(t('buildings.something_wrong'))
            } else NotificationManager.error(t('buildings.something_wrong'))
        } else {
            const response = await client.managers.expenses.setPayment(paymentPlanID, addPaymentMethodPayload);
            if (response.success) {
                onHide();
                NotificationManager.success(t('expenses.set_expenses.setExpenseSuccess'))
                await loadExpenses();
            } else NotificationManager.error(t('buildings.something_wrong'))
        }
        dispatch(hideLoader());
    };

    const onToFirstStepClick = () => {
        setShowConfirmation(false);
        setShowAddPaymentMethod(false);
        setChoosePaymentMethod(true);
        setShowAddExpense(true);
    };

    const onToSecondStepClick = () => {
        setShowConfirmation(false);
        setChoosePaymentMethod(true);
        setShowAddPaymentMethod(true);
    };

    return (
        <div className='set-reccurent-payment'>
            <div className='progress-line'>
                <div className='step'>
                    <div className='progress-step current' onClick={!showFromReport ? onToFirstStepClick : () => {}}><img src={check} /></div>
                    <div className='current-text'>{t('expenses.set_expenses.first_step')}</div>
                </div>

                <div className='divider-line first colored'></div>

                <div className='step'>
                    <div className='progress-step current' onClick={onToSecondStepClick}><img src={check} /></div>
                    <div className='current-text'>{t('expenses.set_expenses.second_step')}</div>
                </div>

                <div className='divider-line second'></div>
                <div className='divider-line-done-second'></div>

                <div className='step'>
                    <div className='progress-step'>3</div>
                    <div className='current-text'>{t('expenses.set_expenses.third_step')}</div>
                </div>
            </div>
            <div className='set-payment-info'>{t('expenses.set_expenses.set_one_time_payment', 
                {
                    amount: (<span class='add-payment-highlithed'>{amount}</span>), 
                    currency: (<span class='add-payment-highlithed'>{currencySign}</span>), 
                    vendorName: (<span class='add-payment-highlithed'>{vendorName}</span>)
                })}
            </div>        

            <div className='confirmation-info-wrapper'>
                <div>
                    <div className='confirmation-header'>{t('expenses.name_of_supplier')}</div>
                    <div className='confirmation-info'>{vendorName}</div>

                    <div className='confirmation-header'>{t('offline_payments.payment_date')}</div>
                    <div className='confirmation-info'>{parsedDate}</div>

                    <div className='confirmation-header'>{t('expenses.payment_method')}</div>
                    <div className='confirmation-info'>{t(`offline_payments.${parsedPaymentMethod}`)}</div>

                    <div className='confirmation-header'>{t('payment_settings.amountHeader')}</div>
                    <div className='confirmation-info'>{amount} <Currency>{currency}</Currency></div>
                </div>
                <img src={cashRegister} />
            </div>         
                    
            <Button
                type='button'
                onClick={onApproveClick}
                rounded={false}
            >                 
                {t('expenses.approve')}
            </Button>
                
        </div>
    )
}

export default Confirmation;